import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import FeaturesListing from "@components/FeaturesListing/FeaturesListing";
import Breadcrumbs from "@components/Breadcrumbs/Breadcrumbs";
import Meta from "@components/Meta/Meta";

const root = process.env.REACT_APP_CMS_STATIC;

function PlanesAsistenciaListado(props) {
  const [matches, setMatches] = useState([]);

  const { rutas } = useSelector(({ Base }) => Base.ContenidoCMS);

  const { planesAsistencia } = useSelector(
    ({ AhorroYCredito }) => AhorroYCredito.AhorroYCredito
  );

  const defRoute = rutas?.filter(
    (route) => route?.name === "Planes de Asistencia Listado"
  );

  useEffect(() => {
    const curSection =
      rutas && rutas.filter((uri) => uri.name === "Planes de Asistencia");
    const rootUri = curSection && curSection[0]?.url;

    let items =
      planesAsistencia &&
      planesAsistencia.map((plan) => ({
        title: plan?.nombre,
        image: root + plan?.imagen?.urls[0],
        // url:(plan?.nombre).replace(/ /gi,"-").toLowerCase(),
        url: rootUri.replace(
          "/:id",
          "/" + (plan?.nombre).replace(/ /gi, "-").toLowerCase()
        ),
        description: plan?.resumenPlan?.html,
        buttons: plan?.botones?.contentItems,
      }));

    setMatches(items);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [planesAsistencia]);

  return (
    <div className="pt-5">
      <Meta
        title={defRoute[0]?.title}
        description={defRoute[0]?.description}
        canonicalUrl={defRoute[0]?.url}
      />
      <Breadcrumbs items={[]} active={defRoute[0]?.name} />
      <h1 className="slogan">{defRoute[0].h1}</h1>
      <FeaturesListing features={matches} validateCustomButtons={true} />
    </div>
  );
}

export default PlanesAsistenciaListado;
